import { DebouncedSearchInput } from 'components/data/DebouncedSearchInput';
import { DocumentTitle } from 'components/DocumentTitle';
import { TablePageLayout } from 'components/page/styled';
import { RouteButtonTabs } from 'components/tabs/RouteButtonTabs';
import { TabRouter } from 'components/tabs/TabRouter';
import {
    ManufacturersDetailPagedDataSource,
    usePagedManufacturersDetailDataSource,
} from 'custom_hooks/data_hooks/data_source/manufacturersDetailDataSource';
import { SearchCreateContainer } from 'pages/Settings/NotificationSubscriptions/styled';
import { ManufacturersTable } from 'pages/Settings/ThirdPartySensorModels/ManufacturersPage/ManufacturersTable';
import {
    useApprovedTabs,
    useTabComponent,
} from 'pages/Settings/ThirdPartySensorModels/useApprovedTabs';
import { useEffect } from 'react';

function dataSourceKey(props: ManufacturersPageProps) {
    return `manufacturer-${props.approved ? 'approved' : 'unapproved'}-table`;
}
export type ManufacturersPageProps = {
    approved: boolean;
};

export function ManufacturersPage() {
    const { routeTabs, isApprovedTab } = useApprovedTabs();

    const dataSource = usePagedManufacturersDetailDataSource({
        name: dataSourceKey({ approved: isApprovedTab }),
        defaultFilter: { isApproved: isApprovedTab },
        defaultSort: [{ field: 'Name', dir: 'asc' }],
    });

    const routeTabsWithContent = useTabComponent({
        tabs: routeTabs,
        ContentComponent,
        props: {
            isApproved: isApprovedTab,
            ds: dataSource,
        },
    });

    const { setFilter } = dataSource;
    useEffect(() => {
        setFilter((cur) => ({
            ...cur,
            isApproved: isApprovedTab,
        }));
    }, [isApprovedTab, setFilter]);

    return (
        <TablePageLayout>
            <DocumentTitle title="Manufacturers" />
            <div className="flex-row flex-wrap mb-20">
                <SearchCreateContainer>
                    <div className="flex-row align-center">
                        <DebouncedSearchInput
                            placeholder="Search"
                            value={dataSource.filter.nameSearch}
                            onChange={(text) =>
                                dataSource.setFilter({
                                    ...dataSource.filter,
                                    nameSearch: text,
                                })
                            }
                        />
                        <RouteButtonTabs routeTabs={routeTabs} className="ml-20" />
                    </div>
                </SearchCreateContainer>
            </div>
            <TabRouter routeTabs={routeTabsWithContent} />
        </TablePageLayout>
    );
}

function ContentComponent({
    isApproved,
    ds,
}: {
    isApproved: boolean;
    ds: ManufacturersDetailPagedDataSource;
}) {
    return <ManufacturersTable dataSource={ds} isApproved={isApproved} />;
}
